export enum EFactsheetClasses {
  US_AMERICAN_STOCKS = 'factsheetUsAmericanStocks',
}
